"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = HeroBanner;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/button/Button");
const HeroBanner_module_scss_1 = __importDefault(require("./HeroBanner.module.scss"));
const sanitise_1 = require("../../../utils/sanitise");
const constants_1 = require("../../../constants");
const dispatchAnalytics_1 = require("../../../utils/dispatchAnalytics");
const bannerUtils_1 = require("../../../utils/bannerUtils");
function HeroBanner({ url, title, logoUrl, ctaText, textColor, esiType, description, logoAltText, imageAltText, previewerSize, tabletImageUrl, backgroundColor, associatedAdvertId, bannerCampaignName, }) {
    const color = (0, sanitise_1.sanitiseColor)(textColor);
    const truncateText = (text, charLimit) => text.substring(0, charLimit);
    let heroBannerContainer = HeroBanner_module_scss_1.default.heroBannerContainer;
    let brandContainer = HeroBanner_module_scss_1.default.brandContainer;
    let logoClassName = HeroBanner_module_scss_1.default.logo;
    let brandCtaContainer = HeroBanner_module_scss_1.default.brandCtaContainer;
    let imageContainer = HeroBanner_module_scss_1.default.imageContainer;
    let contentContainer = HeroBanner_module_scss_1.default.contentContainer;
    let titleClassName = HeroBanner_module_scss_1.default.title;
    let descriptionClassName = HeroBanner_module_scss_1.default.description;
    let contentCtaContainer = HeroBanner_module_scss_1.default.contentCtaContainer;
    if (previewerSize) {
        heroBannerContainer =
            HeroBanner_module_scss_1.default[`preview-heroBannerContainer-${previewerSize}`];
        brandContainer = HeroBanner_module_scss_1.default[`preview-brandContainer-${previewerSize}`];
        logoClassName = HeroBanner_module_scss_1.default[`preview-logo-${previewerSize}`];
        brandCtaContainer = HeroBanner_module_scss_1.default[`preview-brandCtaContainer-${previewerSize}`];
        imageContainer = HeroBanner_module_scss_1.default[`preview-imageContainer-${previewerSize}`];
        contentContainer = HeroBanner_module_scss_1.default[`preview-contentContainer-${previewerSize}`];
        titleClassName = HeroBanner_module_scss_1.default[`preview-title-${previewerSize}`];
        descriptionClassName = HeroBanner_module_scss_1.default[`preview-description-${previewerSize}`];
        contentCtaContainer =
            HeroBanner_module_scss_1.default[`preview-contentCtaContainer-${previewerSize}`];
    }
    let linkOptions;
    if (previewerSize) {
        linkOptions = {
            href: url ? url : undefined,
            target: url ? "_blank" : undefined,
            rel: url ? "noreferrer" : undefined,
        };
    }
    else {
        linkOptions = { href: url };
    }
    return (react_1.default.createElement("div", { className: heroBannerContainer, "data-testid": "hero-banner-container", style: { backgroundColor: (0, sanitise_1.sanitiseColor)(backgroundColor) } },
        react_1.default.createElement("a", Object.assign({}, linkOptions, { className: HeroBanner_module_scss_1.default.heroBanner, "data-testid": "hero-banner-link", onClick: () => {
                (0, dispatchAnalytics_1.dispatchCitrusAnalyticsEvent)({
                    action: "citrusAd.clicked",
                    adId: associatedAdvertId,
                    campaignName: bannerCampaignName,
                    type: (0, bannerUtils_1.getBannerAnalyticsType)(esiType),
                });
            } }),
            react_1.default.createElement("div", { className: brandContainer },
                react_1.default.createElement("img", { src: logoUrl, alt: logoAltText, className: logoClassName, "data-testid": "hero-banner-logo" }),
                react_1.default.createElement("div", { className: brandCtaContainer },
                    react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", style: { color }, labelText: ctaText, "data-testid": "hero-banner-brand-cta" }))),
            react_1.default.createElement("div", { className: imageContainer },
                react_1.default.createElement("img", { alt: imageAltText, src: tabletImageUrl, className: HeroBanner_module_scss_1.default.image, "data-testid": "hero-banner-image" })),
            react_1.default.createElement("div", { className: contentContainer },
                react_1.default.createElement("p", { style: { color }, className: titleClassName, "data-testid": "hero-banner-title" }, truncateText(title, constants_1.TITLE_CHAR_LIMIT)),
                react_1.default.createElement("p", { style: { color }, className: descriptionClassName, "data-testid": "hero-banner-description" }, truncateText(description, constants_1.DESC_CHAR_LIMIT)),
                react_1.default.createElement("div", { className: contentCtaContainer },
                    react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", style: { color }, labelText: ctaText, "data-testid": "hero-banner-content-cta" }))))));
}
